import { Dispatch, SetStateAction } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useLocation } from "react-router-dom";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import Table from "../../../../Components/Table";
import { ListarClientesController } from "../../../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import {
    ClienteInterface,
    IClienteFilter,
} from "../../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";

import { ACESSOS } from "../../../../Routes/Acessos";
import ClientesRow from "../clientesRow";

interface ITabelaCliente {
    setTotalPaginas: Dispatch<SetStateAction<number>>;
    setLstClientes: Dispatch<SetStateAction<ClienteInterface[] | undefined>>;
    setLoading: Dispatch<SetStateAction<boolean>>;
    filter: IClienteFilter;
    totalPaginas: number;
    lstClientes: ClienteInterface[] | undefined;
    loading: boolean;
    setShow: Dispatch<SetStateAction<boolean>>;
    setModal: Dispatch<SetStateAction<IComponentModal | undefined>>;
}

export default function TabelaCliente(props: ITabelaCliente) {
    const ModulosID = {
        Cobranca: {
            id: ACESSOS.COBRANCA.ID_MODULO,
            ds: "Cobrança",
        },
        Atendimento: {
            id: ACESSOS.ATENDIMENTO.ID_MODULO,
            ds: "Atendimento ao Cliente",
        },
    } as { [index: string]: { id: number; ds: string } };

    const columns: Array<ColumnDescription> = [
        {
            dataField: "ID_CONTA",
            text: "",
            formatter: (c, row) => (
                <ClientesRow
                    row={row}
                    setModal={props.setModal}
                    setShow={props.setShow}
                    updateClientes={updateClientes}
                    filter={props.filter}
                />
            ),
        },
    ];
    const location = useLocation();

    const modulo_url = location.pathname.split("/")[1];

    function updateClientes(page: number, filter: IClienteFilter) {
        props.setLoading(true);
        ListarClientesController(page, ModulosID[modulo_url]?.id ?? 0, filter)
            .then((response) => {
                props.setLstClientes(response.LISTA_CLIENTES);
                props.setTotalPaginas(response.NR_TOTAL_PAGINAS);
            })
            .finally(() => {
                props.setLoading(false);
            });
    }
    return (
        <div className="cardsTable mt-3">
            {props.lstClientes || props.loading ? (
                <Table
                    keyField={"ID_CONTA"}
                    data={props.lstClientes || []}
                    columns={columns}
                    rowClasses="checkbox-table"
                    onTableChange={(type, newState) => {
                        updateClientes(newState.page, props.filter);
                    }}
                    noDataIndication={
                        <div className="text-muted text-center">
                            Nenhum cliente encontrado
                        </div>
                    }
                    loading={props.loading}
                    remote={{ pagination: true }}
                    totalPages={props.totalPaginas}
                    noHover
                    noSearch
                />
            ) : (
                <div className="text-muted text-center">
                    Faça a busca com o menu ao lado para ver os clientes
                </div>
            )}
        </div>
    );
}
